// вызов внутри header.js
$.fn.slideNav = function(options) {
	var settings = $.extend(true, {}, options),
		$object = this;

	var $page = app.dom.$page,
		$slides = $object.find('.box'),
		$navsTop = $object.find('.topMenuList__item'),
		$navBlock = $object.find('.slideNav'),
		$navsLeft = $object.find('.slideNav__item'),
		$navs = $object.find('.js-navItem'),
		initHash = location.hash.replace('#', ''),
		oldBgPreSet = '',
		flag = 0,
		flag2 = 0;

	if ($page.hasClass('main')) {
		window.onhashchange = function() {
			var hash = window.location.hash.replace('#', ''),
					$items = $navs.filter('[data-href="' + hash + '"]');

			setSlide(null, $items);
		};

		$navs.on('click', function() {
			// change
			var href = $(this).data('href'),
					$items = $navs.filter('[data-href="'+href+'"]');

			// костыль для вкладки партнеры на блоке контакты
			if(href === 'partners' || href === 'contacts') {
				var $tabsList = $('.tabsList'),
						$tabsBox  = $('.tabsBox');

				$tabsList.find('.tabsList__item').removeClass('active');
				$tabsBox.find('.tabsContent').removeClass('active');

				if(href === 'partners') {
					$tabsList.find('.tabsList__item[data-id="4"]').addClass('active');
					$tabsBox.find('.tabsContent_4').addClass('active');

					$items = $navs.filter('[data-href="contacts"]');
				}

				if(href === 'contacts') {
					$tabsList.find('.tabsList__item[data-id="1"]').addClass('active');
					$tabsBox.find('.tabsContent_1').addClass('active');
				}
			}

			setSlide(href, $items);

			window.history.pushState(null, window.location.hash, '#' + href);
		});


		if (initHash === '') {
			var $initNav = $navs.eq(0);

			setSlide($initNav.data('href'), $initNav);
		}
		else {
			if (!$object.hasClass('object_active')) {
				var $initNav = $navs.eq(0);

				setSlide(initHash);
			}
			else {
				setSlide(initHash);
			}
		}

		function setSlide(targetClass, $navItem) {

			disableScroll();

			var partners = targetClass;

			if(targetClass === 'partners')
				targetClass = 'contacts';

			var $navItem = $navItem || $navs.filter(`[data-href="${targetClass}"]`),
				targetClass = targetClass || $navItem.data('href'),
				$targetSlide = $slides.filter(`[data-id="${targetClass}"]`),
				curBgPreSet = $targetSlide.data('bg-preset');


			if(targetClass === 'actions')
				vueApp.$refs.action.getData();
			if(targetClass === 'shops')
				vueApp.$refs.shops.getData();
			if(targetClass === 'cafe')
				vueApp.$refs.cafe.getData();
			if(targetClass === 'relax')
				vueApp.$refs.relax.getData();
			if(targetClass === 'contacts')
				vueApp.$refs.contacts.getData();
			if(targetClass === 'map') {
				if ($('.map').find('svg').length == 0)
					CommonHelpers.getDataMap(1);
			}

			if (curBgPreSet != 'bgPreSet--0') {
				app.utils.menuClose();
			} else {
				app.utils.menuOpen();
				$('.topMenu').addClass('main');
			};

			$object.data('bg-preset', curBgPreSet);
			$object.add($page).removeClass(oldBgPreSet).addClass(curBgPreSet);

			$navs.removeClass('active');
			$navItem.addClass('active');

			// костыль для вкладки партнеры на блоке контакты
			if(partners === 'partners') {
				$navsTop.removeClass('active');
				$navsTop.filter('[data-href="partners"]').addClass('active');
			}

			// анимация исчезновения
			$slides.removeClass('box_show');
			$slides.find('.fade-text').removeClass('show');
			// $slides.find('.fade-item').removeClass('show');
			// $slides.find('.fade-button').removeClass('show');
			if ((curBgPreSet == 'bgPreSet--0') && (flag2 == 0)) {
				$slides.find('.fade').stop().animate({
					opacity: 0,
					width: 0
				}, 0, function() {
					flag2 = 1;
				});
			};
			// сброс при переходе на другой экран
			$('.js-relax').removeClass('active');

			$('.box_blockShops .categorySlider').fadeOut(450, function() {
				$('.blockShops__left').removeClass('active');
			});

			$('.shops').fadeOut(450, function(){
				$('.map').fadeIn(450);
				$('.js-map-switch').find('.switch__item').removeClass('active');
				$('.js-map-switch').find('.switch__item[data-view="map"]').addClass('active');
			});

			// анимация появления
			$.fn.showItem = function(speed) {
				var $elem = this,
					counter = 0,
					i = setInterval(function() {
					if(counter >= $elem.length)
						clearInterval(i);
					$elem.eq(counter).addClass('show');
					counter++;
					}, speed);
				return $elem;
			};

			$.fn.menuItem = function(callback) {
				var $elem = this,
					counter = 0,
					i = setInterval(function() {

					if(counter >= $elem.length) {
						clearInterval(i);
					}
					$elem.removeClass('active');
					$elem.eq(counter).addClass('active');
					counter++;
					}, 250);
				return $elem;
			};

			$targetSlide.addClass('box_show');
			setTimeout(function(){
				$targetSlide.find('.fade-text').addClass('show');
				// $targetSlide.find('.fade-item').showItem(450);
				if (curBgPreSet == 'bgPreSet--5') $targetSlide.find('.fade-button').showItem(150);

				$targetSlide.find('.fade').stop().animate({
					opacity: 1,
					width: '100%'
				}, 1000, 'easeOutSine', function() {
					if ((curBgPreSet == 'bgPreSet--0') && (flag == 0)) {
						$('.topMenu').find('.js-navItem').menuItem();
						flag = 1;
					};
				});
			}, 300);


			//if ($object.hasClass('object_active')) {
			//	location.hash = targetClass;
			//}
			oldBgPreSet = curBgPreSet;
			$object.data('hash', targetClass);
		};

		function nextSlide() {
			var $curNav = $navs.filter('.active'),
				indexCurNav = $curNav.index();

			if (indexCurNav < ($navsLeft.length - 1)) {
				setSlide('', $navs.eq(indexCurNav + 1));
				// change
				$navsTop.removeClass('active');
				var href = $navs.eq(indexCurNav + 1).data('href');

				window.history.pushState(null, window.location.hash, '#' + href);

				$navsTop.filter('[data-href="'+href+'"]').addClass('active');
			}
		};

		function prevSlide() {
			var $curNav = $navs.filter('.active'),
				indexCurNav = $curNav.index();

			if (indexCurNav > 0) {
				setSlide('', $navs.eq(indexCurNav - 1));
				// change
				$navsTop.removeClass('active');
				var href = $navs.eq(indexCurNav - 1).data('href');

				window.history.pushState(null, window.location.hash, '#' + href);

				$navsTop.filter('[data-href="'+href+'"]').addClass('active');
			}
		};

		$(document).keyup(function(e) {
			if (e.which == 38) {
				prevSlide();
			} else if (e.which == 40) {
				nextSlide();
			}
		});

		function enableScroll() {
			$navBlock.removeClass('loading');
			$object.on('mousewheel', function(event) {
				if (event.deltaY < 0) {
					nextSlide();
				} else {
					prevSlide();
				}
			});
		};

		function disableScroll() {
			$navBlock.addClass('loading');
			$object.off('mousewheel');
			setTimeout(function() {
				enableScroll();
			}, 2000);
		};

		$object.data('slideNav', { enableScroll, disableScroll });

	} else {
		$navsTop.on('click', function() {
			var href = $(this).data('href');

			window.location.href = window.location.hash, '#' + href;
		});
	}
};

$.fn.slideMobile = function(options) {
	var $box = $('.box');

	if ($('.page').hasClass('main')) {
		vueApp.$refs.action.getData();
		vueApp.$refs.shops.getData();
		vueApp.$refs.cafe.getData();
		vueApp.$refs.relax.getData();
		vueApp.$refs.contacts.getData();

		if ($('.map').find('svg').length == 0) CommonHelpers.getDataMap(1);
	}
	// анимация появления
	$.fn.showItem = function(speed) {
		var $elem = this,
			counter = 0,
			i = setInterval(function() {
			if(counter >= $elem.length)
				clearInterval(i);
			$elem.eq(counter).addClass('show');
			counter++;
			}, speed);
		return $elem;
	};

	$box.find('.fade-text').addClass('show');
	$box.find('.fade-button').addClass('show');

	// menu
	function mobileMenuInit() {
		var $topMenu = $('.topMenu'),
			$items = $topMenu.find('.js-navItem'),
			hash = window.location.hash.replace('#',''),
			$target = $('.box[data-id="'+hash+'"]');

		if (hash == 'partners') $target = $('.box[data-id="contacts"]');
		if (hash == 'contacts') $target = $('.box[data-id="contacts"] .blockContacts__left');

		if ($target.length != 0) {
			setTimeout(function(){
				$('html,body').stop().animate({
					scrollTop: $target.offset().top - $('.header__left').outerHeight()
				}, 2000, 'easeOutCubic', function(){
					window.history.pushState(null, null, '/');
				});
			}, 1000);
		};

		$items.each(function(){
			var $item = $(this),
				attr = $item.attr('data-href'),
				$block = $('.box[data-id="'+attr+'"]');

			if (attr == 'partners') $block = $('.box[data-id="contacts"]');
			if (attr == 'contacts') $block = $('.box[data-id="contacts"] .blockContacts__left');

			$item.on('click', function(e) {
				e.preventDefault();

				app.utils.menuClose();

				var attr = $item.attr('data-href');

				if ($('.page').hasClass('main')) {

					$('html, body').removeClass('overflow--detail overflow--list overflow--thanks overflow--map');

					vueApp.$refs.action.changeView('preview');
					vueApp.$refs.shops.changeView('preview');
					vueApp.$refs.cafe.changeView('preview');

					$.each($('.detailPopupMobile'), function(){
						if ($(this).hasClass('open')) $(this).removeClass('open');
					});

					var $target = $('.box[data-id="'+attr+'"]');

					if (attr == 'partners') $target = $('.box[data-id="contacts"]');
					if (attr == 'contacts') $target = $('.box[data-id="contacts"] .blockContacts__left');

					if ($target.length != 0) {
						$('html,body').animate({
							scrollTop: $target.offset().top - $('.header__left').outerHeight()
						}, 2000, 'easeOutCubic');
					};
				} else window.location.href= '/#' + attr;
			});

			if ($block.length != 0){
				setTimeout(function(){
					$(document).on('scroll', function () {
						var generalTop = $('html,body').scrollTop();
							$activeBlock = $block.offset().top;

						if (!$topMenu.hasClass('open')) {
							if ((generalTop + $('.header__left').outerHeight() + 10) > $activeBlock){
								$items.removeClass('active');
								$item.addClass('active');
							} else {
								$item.removeClass('active');
							}
						}
					});
				}, 500);
			}
		});

		var menu = document.getElementById('topMenu');
		var mc = new Hammer(menu);

		mc.on('swiperight', function() {
			app.utils.menuClose();
		});
	};

	mobileMenuInit();
};
